<template>
  <div class="to-be-delivered-page">
    <div class="empty1"></div>
    <addressComponent :frontData="frontData[0]" :isExpress="false" :delivered="false"/>
    <div class="list-title">邮寄清单</div>
    <template v-if="frontData[0].productListRespVOS.length>0">
      <div v-for="(item,index) in frontData[0].productListRespVOS" :key="index">
        <mailingList :itemData="item"/>
      </div>
    </template>
  </div>
</template>

<script>
// eslint-disable-next-line
import addressComponent from '@/components/personalCenter/shippedOrder/addressComponent.vue';
// eslint-disable-next-line
import mailingList from '@/components/personalCenter/shippedOrder/mailingList.vue';

export default {
  props: {
    frontData: {
      type: Array,
      default: () => ([]),
    },
  },
  components: { addressComponent, mailingList },
  data() {
    return {
    };
  },
};
</script>

<style scoped lang="scss">
.to-be-delivered-page {
  margin: 0 36px;
  padding: 36px 0;

  .list-title {
    margin-top: 36px;
    font-weight: bold;
    font-size: 29px;
    line-height: 40px;
  }
}

</style>
